import styled, { css, keyframes } from 'styled-components';
import { COLORS, MQS, SPACINGS, SHADOWS, FONT_FAMILY } from '../../../app/common/constants/styles';

export const RewardsTransactionsHistoryWrapper = css`
    padding: 12px;
    margin-bottom: 32px;
    border-radius: 4px;
    position: relative;
    box-shadow: ${SHADOWS.level1};
    background-color: ${COLORS.white};
`;

export const clip = keyframes`
  0% {transform: rotate(0deg) scale(1)}
  50% {transform: rotate(180deg) scale(0.8)}
  100% {transform: rotate(360deg) scale(1)}
`;

export const HistoryTopContainer = styled.div`
    display: flex;
    align-items: center;
    color: ${COLORS.darkPurple};
    flex-wrap: wrap;

    @media (min-width: ${MQS.mq2Min}) {
        margin: 12px 10px 12px 10px;
        align-items: flex-start;
    }
`;

export const TopButtonsContainer = styled.div`
    width: 100%;
    display: flex;
    margin-bottom: 12px;
    @media (min-width: ${MQS.mq2Min}) {
        display: flex;
        flex: 1 1 33%;
    }
`;

export const RewardButtonContainer = styled.div`
    display: flex;
    width: 100%;
    padding: 2px 1px;
    background: ${COLORS.lightGrey};
    border-radius: 6px;
    @media (min-width: ${MQS.mq2Min}) {
        width: auto;
    }
`;

export const RewardButton = styled.button`
    padding: 6px 12px;
    border-radius: 6px;
    ${FONT_FAMILY.multipleRegularCss};
    cursor: pointer;
    color: ${COLORS.darkPurple};
    background: ${COLORS.lightGrey};
    margin-left: 2px;
    margin-right: 1px;
    border: none;
    flex: 1;

    &.selected {
        background: ${COLORS.white};
    }

    @media (min-width: ${MQS.mq2Min}) {
        width: auto;
        font-size: 18px;
    }
`;

export const Title = styled.h2`
    display: flex;
    flex: 1 1 33%;
    justify-content: flex-end;
    margin-right: 12px;
    font-size: 15px;
    ${FONT_FAMILY.multipleRegularCss};
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${COLORS.darkPurple};
    @media (min-width: ${MQS.mq2Min}) {
        justify-content: center;
        margin: 2px;
        font-size: 26px;
        flex: 1;
    }
`;

export const TitleNoTableNavButtons = styled(Title)`
    justify-content: left;
`;

export const DropdownContainer = styled.div`
    display: flex;
    flex: 1 1 33%;
    margin-left: 12px;
    justify-content: flex-start;
    @media (min-width: ${MQS.mq2Min}) {
        margin-left: 0;
        justify-content: flex-end;
    }
`;

export const DropdownSelector = styled.div`
    background: ${COLORS.lightGrey};
    border-radius: 4px;
    display: inline-table;
    font-size: 14px;
    @media (min-width: ${MQS.mq2Min}) {
        font-size: 18px;
    }

    & ul {
        top: 35px;
        right: 0;
        min-width: 140px;
    }

    & button {
        padding: ${SPACINGS.base}px ${SPACINGS.base * 2}px;
    }
`;

export const EarntSpentSummaryContainer = styled.div`
    display: flex;
    justify-content: center;
    font-size: 11px;
    margin: 12px 0 6px 0;
    @media (min-width: ${MQS.mq2Min}) {
        font-size: 16px;
    }
`;

export const EarnedText = styled.span`
    color: ${COLORS.green};
    margin-right: 6px;
`;

export const SpentText = styled.span`
    color: ${COLORS.rakutenRed};
    margin-left: 6px;
`;

export const FetchingTransactions = styled.div`
    background: transparent !important;
    width: 24px;
    height: 24px;
    border-radius: 100%;
    border: 2px solid;
    border-color: ${COLORS.rakutenRed};
    border-bottom-color: transparent;
    animation: ${clip} 0.75s 0s infinite linear;
    animation-fill-mode: both;
    margin-top: ${SPACINGS.base * 4}px;
`;

export const ErrorMessage = styled.h3`
    font-size: 14px;
    font-weight: normal;
    color: ${COLORS.grey};
    margin: 0px 10px;
`;

export const RewardsTransactionsHistoryWrapperOpacity = css`
    ${RewardsTransactionsHistoryWrapper}
    opacity: .5;
`;
